<!--能力体系-->
<template>
  <a-card>
    <div class="search">
      <a-form-model layout="inline" :model="searchForm">
        <a-form-model-item label="能力体系名称">
          <a-input :maxLength="30" allowClear class="serach-item" v-model="searchForm.name" placeholder="请输入能力体系名称" />
        </a-form-model-item>
        <a-form-model-item style="margin-right: 35px">
          <a-button @click="getPageList(1)" type="primary" html-type="button"> 查询 </a-button>
          <a-button @click="searchReset" style="margin-left: 10px"> 重置 </a-button>
        </a-form-model-item>
        <a-form-model-item v-permission="`abilitySystem.Add`">
          <a-button @click="modelForm.visible = true" icon="plus" type="primary">添加能力体系</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div style="overflow: auto">
      <a-table
        style="min-width: 800px"
        :columns="columns"
        :rowKey="(text, index) => text.id + index"
        :pagination="false"
        :loading="tableRelevant.tableLoading"
        :scroll="{ y: 550 }"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <span v-auth="`abilitySystem.Status`" slot="status" slot-scope="text">
          <a-switch @change="tableStatusChange(text)" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
        </span>
        <div slot="action" slot-scope="text">
          <a v-permission="`abilitySystem.Edit`" @click="edit(text)" style="margin-right: 10px" href="javaScript:;">
            <a-icon type="edit" />
            编辑</a
          >
          <a v-permission="`abilitySystem.Type`" @click="type(text)" style="margin-right: 10px" href="javaScript:;">
            <a-icon type="gateway" />
            评价类型</a
          >
          <a v-permission="`abilitySystem.Grade`" @click="grade(text)" style="margin-right: 10px" href="javaScript:;">
            <a-icon type="sort-ascending" />
            评价等级</a
          >
          <a-popconfirm title="确认删除此模板？" @confirm="del(text)">
            <a v-permission="`abilitySystem.Delete`" style="color: red" href="javaScript:;">
              <a-icon type="delete" />
              删除</a
            >
          </a-popconfirm>
        </div>
      </a-table>
    </div>

    <!--添加/编辑能力体系-->
    <a-modal
      v-model="modelForm.visible"
      :centered="true"
      :destroyOnClose="true"
      :title="modelForm.title"
      :confirm-loading="modelForm.confirmLoading"
      @cancel="modelFormCancel"
      @ok="modelFormOk"
      width="800px"
    >
      <a-form-model ref="myModelForm" style="max-height: 400px; overflow-y: auto" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }" :model="modelForm.data" :rules="modelForm.rules">
        <a-form-model-item label="体系名称" prop="name">
          <a-input @change="(e) => (modelForm.data.name = e.target.value.replace(/\s*/g, ''))" v-model="modelForm.data.name" placeholder="请输入体系名称" />
        </a-form-model-item>
        <a-form-model-item label="描述" prop="description">
          <a-textarea v-model="modelForm.data.description" placeholder="请输入内容" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="modelForm.data.enabled">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!--评价类型-->
    <a-modal v-model="abilitySystemType.visible" centered destroyOnClose :footer="null" width="1300px" title="评价类型">
      <AbilitySystemType :abilitySystemTypeId="abilitySystemType.id" />
    </a-modal>

    <!--评价等级-->
    <a-modal v-model="abilitySystemGrade.visible" centered destroyOnClose :footer="null" width="1300px" title="评价等级">
      <AbilitySystemGrade :abilitySystemGradeId="abilitySystemGrade.id" />
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import AbilitySystemType from './components/AbilitySystemType'
import AbilitySystemGrade from './components/AbilitySystemGrade'

const columns = [
  {
    title: '能力体系名称',
    dataIndex: 'name',
  },
  {
    title: '描述',
    dataIndex: 'description',
    ellipsis: true,
  },
  {
    title: '状态',
    width: 150,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
  },
  {
    title: '操作',
    width: 350,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'AbilitySystem',
  components: {
    AbilitySystemType,
    AbilitySystemGrade,
  },
  data() {
    return {
      columns,
      searchForm: {
        name: undefined,
      },
      //表格相关
      tableRelevant: tableRelevant.call(this),
      //添加、编辑能力体系相关
      modelForm: {
        visible: false,
        confirmLoading: false,
        title: '添加能力体系',
        data: {
          id: undefined,
          name: '',
          description: '',
          enabled: true,
        },
        rules: {
          name: [
            { required: true, message: '请输入能力体系名称', trigger: 'blur' },
            { min: 2, max: 30, message: '能力体系长度为 2 到 30个字符', trigger: 'blur' },
          ],
        },
      },
      //评价类型弹框
      abilitySystemType: {
        visible: false,
        id: '',
      },
      //评价等级弹框
      abilitySystemGrade: {
        visible: false,
        id: '',
      },
    }
  },
  mounted() {
    this.getPageList()
  },
  methods: {
    //获取能力体系列表
    getPageList(pageIndex) {
      if (pageIndex) {
        this.tableRelevant.tablePagination.current = pageIndex
      }
      const params = {
        // pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        // pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      }
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.getAbilityEvaluationSys(params)
        .then((res) => {
          const { data } = res
          this.tableRelevant.tableDataSource = data
          this.tableRelevant.tablePagination.total = data.length
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    //重置
    searchReset() {
      this.searchForm = {
        name: undefined,
      }
      this.getPageList(1)
    },
    //能力体系状态切换
    tableStatusChange(val) {
      this.$message.destroy()
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.statusAbilityEvaluationSys(val.id)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
        })
        .catch(() => {
          val.enabled = !val.enabled
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //编辑能力体系
    edit(val) {
      this.modelForm.title = '编辑能力体系'
      for (let key in this.modelForm.data) {
        this.modelForm.data[key] = val[key]
      }
      this.modelForm.visible = true
    },
    //评价类型
    type(val) {
      this.abilitySystemType.visible = true
      this.abilitySystemType.id = val.id
    },
    //评价等级
    grade(val) {
      this.abilitySystemGrade.visible = true
      this.abilitySystemGrade.id = val.id
    },
    //删除能力体系
    del(val) {
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.deleteAbilityEvaluationSys(val.id)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
          this.getPageList(1)
        })
        .finally(() => (this.tableRelevant.tableLoading = false))
    },

    //弹出框确认
    modelFormOk() {
      this.$refs.myModelForm.validate((valid) => {
        if (valid) {
          const bool = this.modelForm.title === '添加能力体系'
          const Ajax = bool ? this.$http.ReportService.addAbilityEvaluationSys : this.$http.ReportService.updateAbilityEvaluationSys
          const form = new FormData()
          for (let key in this.modelForm.data) {
            form.append(key, this.modelForm.data[key])
          }
          if (bool) {
            form.delete('id')
          }
          this.modelForm.confirmLoading = true
          Ajax(form)
            .then((res) => {
              const { message } = res
              this.$message.success(message)
              this.modelFormCancel()
              this.getPageList(1)
            })
            .finally(() => {
              this.modelForm.confirmLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //弹出框取消
    modelFormCancel() {
      this.modelForm.visible = false
      this.modelForm.title = '添加能力体系'
      this.modelForm.data = {
        id: undefined,
        name: '',
        description: '',
        enabled: true,
      }
    },
  },
}
</script>

<style scoped>
.serach-item {
  width: 180px;
  margin-bottom: 15px;
}
</style>
